import React from 'react';
import {bindActionCreators} from 'redux';
import {connect} from 'react-redux';
import {browserHistory} from 'react-router';
import {message, Popconfirm, Modal, notification, Icon, Tooltip} from 'antd';
import {SmallPopover} from 'icsoc-antd-ex';
import UnionTableList from 'Components/union/unionTableList';
import CommonTable from 'Components/common/commonTable';
import IconFont from 'Components/common/iconFont';
import tListActions from 'Actions/taskManage/list';
import tDetailActions from 'Actions/taskManage/detail';
import {getByteLen, cutStr, getWeekDays} from 'Utils';
import sort from 'Utils/sort';
import moment from 'moment';
import config from './config';
import UploadModal from './modal/uploadModal';

class TableList extends UnionTableList {
  constructor(props) {
    super(props);
    this.state = {
      uploadModalId: -1,
      isUploadModalVisible: false,
    };
  }
  
  componentWillMount() {
    this.customize = localStorage.getItem('customize') || '';
  }

  handleAction = (type, data) => {
    const {setTableListLoading} = this.props;

    // 确认暂停任务 /启动任务 /取消任务
    if (
      type === 'confirmPause' ||
      type === 'startUp' ||
      type === 'confirmCancel'
    ) {
      const {
        actions,
        getTableList,
        searchData,
        pageStatus: {pageNum, pageSize},
        tableListData: {total = 0} = {},
      } = this.props;

      setTableListLoading();
      actions[type](data)
        .then(res => {
          const {payload: {code} = {}} = res || {};

          if (parseInt(code, 10) === 200) {
            if (type === 'confirmCancel') {
              message.success(`成功清空${ res.payload.data }条呼叫！`);
            }
            const newPageNum = Math.ceil((total - 1) / pageSize);
            const turnPageNum =
              pageNum < newPageNum ? pageNum : newPageNum || 1;

            this.setPageStatus({
              pageNum: turnPageNum,
            });
            getTableList({
              ...searchData,
              pageNum: turnPageNum,
              pageSize,
            });
          }
        })
        .finally(() => {
          setTableListLoading();
        });
    } else {
      this[type](data);
    }
  };

  // 导入数据
  upload = id => {
    this.setState(
      {
        uploadModalId: id,
      },
      () => {
        this.setUploadModalVisible();
      },
    );
  };

  // 设置导入数据弹框是否可见
  setUploadModalVisible = () => {
    const {isUploadModalVisible} = this.state;

    this.setState({
      isUploadModalVisible: !isUploadModalVisible,
    });
  };

  // 导入数据弹框点击导入
  uploadModalOnOk = () => {
    const {
      getTableList,
      searchData,
      pageStatus: {pageNum, pageSize} = {},
    } = this.props;

    this.setUploadModalVisible();
    getTableList({
      ...searchData,
      pageNum,
      pageSize,
    });
  };

  // 编辑任务
  edit = record => {
    const {setEditModalVisible, actions} = this.props;
    setEditModalVisible();
    actions.setEditModalData(record);
  };

  // 查看详情
  checkDetail = (record) => {
    const {detailActions} = this.props;
    const commitTimeStart = getWeekDays()[0].format('x');
    const commitTimeEnd = getWeekDays()[1].format('x');

    detailActions.setSearchData({
      taskId: record.id,
      commitTimeStart,
      commitTimeEnd,
      orderKey: 'commit_time',
    });

    browserHistory.push({
      pathname: '/taskManage/detail',
    });
  };

  // 导出
  download = id => {
    const user = window.localStorage.getItem('user') || '{}';
    const vccId = JSON.parse(user).profile?.vcc_id;

    window.open(`/robot/taskinfo/export?taskId=${id}&vccId=${vccId}`);
  };

  // 删除
  delet = ({id}) => {
    const {
      actions,
      getTableList,
      searchData,
      pageStatus: {pageNum, pageSize} = {},
    } = this.props;
    actions.deletCheck(id).then(res => {
      if (res.payload.code === 200) {
        Modal.confirm({
          title: '删除提醒',
          content: '确认要删除这条任务吗?',
          onOk() {
            actions.delet(id).then(res => {
              if (res.payload.code === 200) {
                message.success('任务删除成功！');
                getTableList({
                  ...searchData,
                  pageNum,
                  pageSize,
                });
              }
            });
          },
        });
      }
    });
  };

  // 异常数据显示
  showErrorMsg=(record)=>{
    notification.destroy();
    notification.error({
      message: '错误',
      duration:null,
      bottom:0,
      placement:'bottomRight',
      description:record.nlpErrorMsg || '暂无错误信息',
    });
  }

  render() {
    const {
      tableListData: {data = [], total = 0},
      loading,
      pageStatus,
      pageStatus: {pageNum, pageSize},
      login
    } = this.props;
    const {uploadModalId, isUploadModalVisible} = this.state;

    const columns = (pageStatus, handleAction) =>
      [
        {
          title: '序号',
          key: 'key',
          dataIndex: 'key',
          width: 60,
          fixed: 'left',
          render: (text, record, index) => {
            const {pageNum, pageSize} = pageStatus;

            return sort({pageNum, pageSize, index});
          },
        },
        {
          title: 'TaskID',
          dataIndex: 'id',
          key: 'id',
          width: 80,
          fixed: 'left',
          render: text => text || '--',
        },
        {
          title: '任务名称',
          dataIndex: 'taskName',
          key: 'taskName',
          width: 260,
          fixed: 'left',
          render: (text,record) =>
            text ? (
              record.nlpErrorFlag==1 ?
              <span title={text} style={{color:'#F63C3C',cursor:'pointer'}} onClick={()=>this.showErrorMsg(record)}>
                {getByteLen(text) > 36 ? `${cutStr(text, 36)}...` : text}
              </span>
              :
              <span title={text}>
                {getByteLen(text) > 36 ? `${cutStr(text, 36)}...` : text}
              </span>
            ) : (
              '--'
            ),
        },
        {
          title: '任务状态',
          key: 'statusName',
          dataIndex: 'statusName',
          width: 120,
          render: (text, record) => {
            let className = '';

            switch (record.status) {
              case 0:
                className = 'gray';
                break;
              case 1:
                className = 'blue';
                break;
              case 2:
                className = 'yellow';
                break;
              case 3:
                className = 'red';
                break;
              case 4:
                className = 'green';
                break;
              default:
                break;
            }

            return (
              <span className="task-status">
                <i className={className} />
                {config[record.status] || '--'}
              </span>
            );
          },
        },
         // login.permissionsList.includes('taskManageList.detail')
        {
          title: '未执行数量',
          dataIndex: 'notCallNum',
          key: 'notCallNum',
          width: 120,
          render: (text,record) => {
            return <span style={{color:'#40aefc',cursor:'pointer'}} onClick={() => handleAction('checkDetail', record)}>{text}</span>
          }
        },
        {
          title: '话术名称',
          key: 'strategyName',
          dataIndex: 'strategyName',
          width: 300,
          render: text =>
            text ? (
              <span title={text}>
                {getByteLen(text) > 36 ? `${cutStr(text, 36)}...` : text}
              </span>
            ) : (
              '--'
            ),
        },
        {
          title: '工作时间名称',
          key: 'workTimeName',
          dataIndex: 'workTimeName',
          width: 300,
          render: text =>
            text ? (
              <span title={text}>
                {getByteLen(text) > 36 ? `${cutStr(text, 36)}...` : text}
              </span>
            ) : (
              '--'
            ),
        },
        this.customize === 'txgg'
          ? {
              title: '今日接通数',
              dataIndex: 'answerNum',
              key: 'answerNum',
              width: 120,
              render: text => text || '--',
            }
          : {},
        this.customize === 'txgg'
          ? {
              title: '今日接通率',
              dataIndex: 'rate',
              key: 'rate',
              width: 120,
              render: text => text || '--',
            }
          : {},
        {
          title: '并发数',
          dataIndex: 'queueNumber',
          key: 'queueNumber',
          width: 120,
          render: text => String(text) || '--',
        },
        {
          title: '提交时间',
          key: 'commitTime',
          dataIndex: 'commitTime',
          width: 240,
          render: text => moment(text).format('YYYY-MM-DD HH:mm:ss'),
        },
        {
          title: '创建人',
          dataIndex: 'creator',
          key: 'creator',
          width: 120,
          render: text => text || '--',
        },
        {
          title: '创建时间',
          dataIndex: 'createDate',
          key: 'createDate',
          width: 200,
          render: text =>
            (text && moment(text).format('YYYY-MM-DD HH:mm:ss')) || '--',
        },
        {
          title: '修改人',
          dataIndex: 'modifier',
          key: 'modifier',
          width: 120,
          render: text => text || '--',
        },
        {
          title: '修改时间',
          dataIndex: 'updateDate',
          key: 'updateDate',
          width: 200,
          render: text =>
            (text && moment(text).format('YYYY-MM-DD HH:mm:ss')) || '--',
        },
        {
          title: () => (
              <span>
                操作
                <Tooltip placement="rightTop" overlayClassName="sessionFlowSettingTooltip" title={<span>1. 状态变更是非及时更新(至多5min).<br />
                  2. 进行中状态才可暂停.<br />3. 暂停状态才可重启或清空.<br />4. 已完成的任务方可删除,删除后任务无法恢复.
                                                                                                  </span>}>
                    <Icon type="info-circle" style={{ marginLeft: '4px', color: '#969799' }} />
                </Tooltip>
              </span>
          ),
          key: 'operate',
          dataIndex: 'operate',
          width: 200,
          fixed: 'right',
          render: (text, record) => {
            const {status, id} = record;
            const statusNum = parseInt(status, 10);

            const isUploadDisable = statusNum === 3 ? ' is-disable' : '';
            const isEditDisable =
              statusNum === 0 ||
              statusNum === 1 ||
              statusNum === 2 ||
              statusNum === 4
                ? ''
                : ' is-disable';
            const isStartUpDisable = statusNum === 2 ? '' : ' is-disable';
            const isDownloadDisable =
              statusNum === 4 || statusNum === 3 ? '' : ' is-disable';
            const isCancelDisable =
              statusNum === 0 || statusNum === 1 || statusNum === 2
                ? ''
                : ' is-disable';
            const isDeletable =
                statusNum === 0 || statusNum ===2 || statusNum === 3 || statusNum === 4 ? '': ' is-disable';
            return (
              <div className="operate">
                {
                  login.permissionsList.includes('taskManageList.importTask') ?
                    <SmallPopover
                      type="white"
                      content="导入数据"
                      className={`tooltip${isUploadDisable}`}>
                    <IconFont
                      type="icon-robotimport"
                      onClick={
                        isUploadDisable === ' is-disable'
                          ? null
                          : () => handleAction('upload', record.id)
                      }
                    />
                    </SmallPopover>
                : null}
                {
                  login.permissionsList.includes('taskManageList.editTask') ?
                    <SmallPopover
                      type="white"
                      content="编辑"
                      className={`tooltip${isEditDisable}`}>
                    <IconFont
                      type="icon-robotedit"
                      onClick={
                        isEditDisable === ' is-disable'
                          ? null
                          : () => handleAction('edit', record)
                      }
                    />
                    </SmallPopover>
                : null}
                {login.permissionsList.includes('taskManageList.startOrPauseTask') ?
                  (statusNum === 1 ?  (
                    <SmallPopover type="white" content="暂停" className="tooltip">
                      <Popconfirm
                        placement="leftBottom"
                        title={
                          <div>
                            暂停后该任务未呼出的用户暂
                            <br />
                            时无法继续呼出，确认暂停么?
                          </div>
                        }
                        onConfirm={() => handleAction('confirmPause', record.id)}>
                        <IconFont type="icon-robotpause" />
                      </Popconfirm>
                    </SmallPopover>
                    ) : (
                    <SmallPopover
                      type="white"
                      content="启动"
                      className={`tooltip${isStartUpDisable}`}>
                      <IconFont
                        type="icon-robottriangle-right-o"
                        onClick={
                          isStartUpDisable === ' is-disable'
                            ? null
                            : () => handleAction('startUp', record.id)
                        }
                      />
                    </SmallPopover>
                    )
                  )
                 : null}
                {
                  login.permissionsList.includes('taskManageList.cancelTask') ?
                  <SmallPopover
                    type="white"
                    content="清空任务"
                    className={`tooltip${isStartUpDisable}`}>
                    {isStartUpDisable ? (
                      <IconFont type="icon-robotclose-circle" />
                    ) : (
                      <Popconfirm
                        placement="leftBottom"
                        title={
                          <div>
                            清空任务呼叫数据,任务保留
                            <br />
                            确认清空么?
                          </div>
                        }
                        onConfirm={() =>
                          handleAction('confirmCancel', record.id)
                        }>
                        <IconFont type="icon-robotclose-circle" />
                      </Popconfirm>
                    )}
                  </SmallPopover>
                :null }
               {
                 login.permissionsList.includes('taskManageList.deleteTask') ?
                 <SmallPopover 
                   type="white" 
                   content="删除"
                   className={`tooltip${isDeletable}`}>
                   {isDeletable ? (
                       <IconFont type="icon-robottrash" />
                   ) : (
                       <Popconfirm
                         placement="leftBottom"
                         title={
                             <div>
                               删除任务后将无法恢复,请谨慎操作
                               <br />
                               确认删除么?
                             </div>
                           }
                         onConfirm={() =>
                               handleAction('delet', {id})
                           }>
                         <IconFont type="icon-robottrash" />
                       </Popconfirm>
                   )}
                 </SmallPopover>
               : null}
              </div>
            );
          },
        },
      ].filter(item => JSON.stringify(item) !== '{}');
    return (
      <React.Fragment>
        <CommonTable
          key={this.customize}
          columns={columns(pageStatus, this.handleAction)}
          dataSource={[...data]}
          rowKey="id"
          loading={loading}
          extraHeight={48}
          scroll={{x: this.customize === 'txgg' ? 2760 : 1800}}
          onChange={this.handleTableChange}
          pagination={{
            current: pageNum,
            total: total && parseInt(total, 10),
            pageSize,
            showTotal: () => `共 ${total} 条`,
          }}
        />

        <UploadModal
          id={uploadModalId}
          visible={isUploadModalVisible}
          onCancel={this.setUploadModalVisible}
          onOk={this.uploadModalOnOk}
        />
      </React.Fragment>
    );
  }
}

const mapStateToProps = ({taskManageList,login}) => ({
  tableListData: taskManageList.tableListData,
  pageStatus: taskManageList.pageStatus,
  searchData: taskManageList.searchData,
  login,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(tListActions, dispatch),
  detailActions: bindActionCreators(tDetailActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(TableList);
